import React from 'react';
import ProfileLayout from '../components/Profile/ProfileLayout';

const ProfilePage = () => {
  return <ProfileLayout />;
};

export default ProfilePage;
